import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=2037976a&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"
import style0 from "./setup.vue?vue&type=style&index=0&id=2037976a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037976a",
  null
  
)

export default component.exports